import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import { analyticsReset, SEGMENT_EVENTS, trackEvent } from '../utils/Segment';
import { resetStore, setSelectedFilters } from '../store/action/common';
import { doPlansSuccess } from '../store/action/plan';
import { extractJSON } from '../services/jsonUtil';
import { LOCAL_STORAGE_CONSTANT } from '../constants/app';
import { axiosInstance, resetAxiosInstance } from '../api';
import { APP_ROUTES } from '../route';

// Ends the session completely, so nothing from this account leaks into the
// next one signed in on the same browser: all of localStorage (including the
// cached community uid), sessionStorage, cookies, auth headers and the Redux
// state. Pass { reload: false } to keep the page alive, e.g. so a toast stays
// visible after deleting the account.
const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxUser = useSelector(state => state.user?.user);

  return useCallback(
    ({ reload = true } = {}) => {
      const user = reduxUser || extractJSON(LOCAL_STORAGE_CONSTANT.USER);
      trackEvent(SEGMENT_EVENTS.LOGOUT, {
        user_id: user?.id,
        free_trial_active: user?.attributes?.free_trial || false,
        subscription_active:
          user?.attributes?.subscription_details?.subscribed || false,
      });
      dispatch(resetStore());
      dispatch(setSelectedFilters({ selectedFilters: [], skipSave: true }));
      dispatch(doPlansSuccess([]));

      localStorage.clear();
      sessionStorage.clear();
      Object.keys(Cookies.get()).forEach(cookieName => {
        Cookies.remove(cookieName);
      });

      resetAxiosInstance();
      delete axiosInstance.defaults.headers.common.uid;
      delete axiosInstance.defaults.headers.common.client;
      delete axiosInstance.defaults.headers.common['access-token'];

      navigate(APP_ROUTES.ROOT);
      analyticsReset();
      window?.Cohere?.stop();
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      if (reload) {
        window.location.reload();
      }
    },
    [dispatch, navigate, reduxUser],
  );
};

export default useLogout;
